import { ScreenHeaderWithInbox } from '@app/components/Screen'
import { ROUTES } from '@app/constants'
import { ModalType } from '@app/types'
import { Icon, IconColor, IconTypes, Modal } from '@app/ui'
import { FC, memo } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface TelegramBotSelectionProps {
  open: boolean
  onClose: () => void
}

const TelegramBotSelection: FC<TelegramBotSelectionProps> = ({
  open,
  onClose
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <StyledModal open={open} onClose={onClose} type={ModalType.fullscreen} zIndex={1005}>
      <ScreenHeaderWithInbox
        title={t('appMenu.telegramAutomatisation')}
        hideLogo={true}
        showBackButton={true}
        onBackClick={onClose}
        headerBackgroundColor="transparent"
        titleAlign="left"
      />
      <StyledContent>
        <StyledContentHeader>
          <div>
            <img src="/assets/images/logos_telegram.png"/>
          </div>
          <p className="title">{t('appMenu.telegramAutomationBots')}</p>
        </StyledContentHeader>
        <StyledContentBody onClick={() => {
          navigate(ROUTES.TelegramAutoShare.short)
          onClose()
        }}>
          <div className="start">
            <div className="wrapper">
              <img src="/assets/images/link.png"/>
            </div>
          </div>
          <div className="middle">
            <p className="title">{t('appMenu.autoshareContentBot')}</p>
            <p className="subtitle">{t('appMenu.fromAppToTelegram')}</p>
          </div>
          <div className="end">
            <Icon
              type={IconTypes.angleRight}
              color={IconColor.white}
              width={23}
              height={23}
            />
          </div>
        </StyledContentBody>
      </StyledContent>
    </StyledModal>
  )
}

const StyledContent = styled.div`
  width: auto;
  height: 100%;
  padding-top: var(--standard-header-height);
  margin: 0 12px;
`

const StyledContentBody = styled.div`
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  border: 1px solid var(--Woodsmoke-900, #262626);
  background: #1E1E21;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.40);
  .start {
    flex: 0 0 10%;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    padding-left: 12px;
    .wrapper {
      border-radius: 8px;
      border: 0.5px solid #9B9BAC;
      background: var(--input-50, rgba(39, 39, 42, 0.50));
      backdrop-filter: blur(8px);
      padding: 12px;
    }
  }
  .middle {
    flex: 0 0 80%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .title {
      padding-bottom: 8px;
      color: var(--zinc-300, #D4D4D8);
      font-size: 13px;
      font-weight: 300;
    };
    .subtitle {
      color: var(--zinc-400, #A1A1AA);
      text-edge: cap;
      font-size: 10px;
      font-weight: 400;
      text-transform: capitalize;
    }
  }
  .end {
    flex: 0 0 10%;
    .title {

    }
  }
`

const StyledContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-bottom: 24px;
  align-self: stretch;
  .title {
    color: var(--zinc-200, #E4E4E7);
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`

const StyledModal = styled(Modal)`
  .type-fullscreen {
    background-color: none;
    background: radial-gradient(251.29% 100.03% at 47.46% 0%, rgba(0, 128, 255, 0.40) 0%, rgba(24, 98, 136, 0.00) 29.96%), linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.40) 100%), var(--zinc-800, #27272A);
  }
`

export default memo(TelegramBotSelection)